import { render } from "./MyProgress.vue?vue&type=template&id=122249b6&scoped=true"
import script from "./MyProgress.vue?vue&type=script&lang=js"
export * from "./MyProgress.vue?vue&type=script&lang=js"

import "./MyProgress.vue?vue&type=style&index=0&id=122249b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lms-v3-backend/lms-v3-backend/.vapor/build/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122249b6"]])

export default __exports__